import * as yup from "yup";

const NewHomeSchema = yup.object().shape({
  first_name: yup.string().required().label("First name"),
  type: yup.string().nullable().required("House Type is required"),
  quality: yup.mixed().required("Quality is required"),
});

export default NewHomeSchema;
